import { render, staticRenderFns } from "./PartnerEditDialog.vue?vue&type=template&id=87bcc33a"
import script from "./PartnerEditDialog.vue?vue&type=script&lang=js"
export * from "./PartnerEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports